import {
  Box,
  Typography,
  Paper,
  Container
} from '@mui/material';
import {
  ConstructionOutlined as ConstructionIcon,
  ScheduleOutlined as ScheduleIcon
} from '@mui/icons-material';
import useCommonMediaQuery from '../../hooks/useCommonMediaQuery';

const ComingSoon = ({ 
  title = "Coming Soon", 
  description = "This feature is currently under development and will be available soon.",
  icon: CustomIcon = ConstructionIcon,
  showSchedule = true 
}) => {
  const isMobile = useCommonMediaQuery('md');

  return (
    <Container maxWidth="md" sx={{ py: 4 }}>
      <Paper
        elevation={0}
        sx={{
          p: { xs: 3, md: 6 },
          textAlign: 'center',
          borderRadius: 3,
          background: 'linear-gradient(135deg, #f8fafc 0%, #e2e8f0 100%)',
          border: '1px solid #e2e8f0',
          minHeight: { xs: '60vh', md: '70vh' },
          display: 'flex',
          flexDirection: 'column',
          justifyContent: 'center',
          alignItems: 'center'
        }}
      >
        <Box
          sx={{
            mb: 4,
            p: 3,
            borderRadius: '50%',
            backgroundColor: '#F1AC2F',
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            width: { xs: 80, md: 100 },
            height: { xs: 80, md: 100 },
            boxShadow: '0 8px 32px rgba(241, 172, 47, 0.3)'
          }}
        >
          <CustomIcon 
            sx={{ 
              fontSize: { xs: 40, md: 50 },
              color: '#ffffff'
            }} 
          />
        </Box>

        <Typography
          variant={isMobile ? "h4" : "h3"}
          component="h1"
          sx={{
            fontWeight: 700,
            color: '#1e293b',
            mb: 2,
            background: 'linear-gradient(135deg, #1e293b 0%, #475569 100%)',
            backgroundClip: 'text',
            WebkitBackgroundClip: 'text',
            WebkitTextFillColor: 'transparent'
          }}
        >
          {title}
        </Typography>

        <Typography
          variant={isMobile ? "body1" : "h6"}
          sx={{
            color: '#64748b',
            mb: 4,
            maxWidth: '600px',
            lineHeight: 1.6
          }}
        >
          {description}
        </Typography>

        {showSchedule && (
          <Box
            sx={{
              display: 'flex',
              alignItems: 'center',
              gap: 1,
              p: 2,
              backgroundColor: 'rgba(241, 172, 47, 0.1)',
              borderRadius: 2,
              border: '1px solid rgba(241, 172, 47, 0.2)'
            }}
          >
            <ScheduleIcon sx={{ color: '#F1AC2F', fontSize: 20 }} />
            <Typography
              variant="body2"
              sx={{
                color: '#92400e',
                fontWeight: 500
              }}
            >
              Stay tuned for updates!
            </Typography>
          </Box>
        )}
      </Paper>
    </Container>
  );
};

export default ComingSoon;
